































import Vue from "vue";
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import iwInputRadioGroup from "@/encoding/components/buildingBlocks/InputRadioGroup.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";

export default Vue.extend({
    name: "EnforcementMeasuresRegisterConsulted",

    components: {
        iwInputRadioGroup: iwInputRadioGroup,
        iwTooltip: iwTooltip,
    },

    data: function() {
        return {
            pathInStore: "property.certificates.enforcementMeasuresRegisterConsulted",
            specificId: uuidv4() as string,
            options: [
                { value: true, label: "yes" },
                { value: false, label: "no" },
                { value: "not_determined", label: "not_determined" },
            ],
        };
    },

    computed: {
        ...mapGetters({
            getClassifiedProperty: "FormModule/getValue",
            getError: "FormModule/getErrorObjectByPath"
        }),

        errorMessage: function(): string {
            return this.getError(this.pathInStore);
        },

        value: function(): string | boolean {
            const current = this.getClassifiedProperty(this.pathInStore);
            if (current === true) return true;
            if (current === false) return false;
            return "not_determined";
        }
    },

    created: function(): void {
        const current = this.getClassifiedProperty(this.pathInStore);
        if (current !== true && current !== false) {
            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStore,
                value: null
            });
        }
    },

    methods: {
        updateValue: function(selectedValue: string | boolean): void {
            this.$store.dispatch("FormModule/addValue", {
                path: this.pathInStore,
                value: selectedValue === "not_determined" ? null : selectedValue
            });
        }
    }
});
